import { render, staticRenderFns } from "./WhoIAmThanks.vue?vue&type=template&id=1920f453&lang=pug&"
import script from "./WhoIAmThanks.vue?vue&type=script&lang=js&"
export * from "./WhoIAmThanks.vue?vue&type=script&lang=js&"
import style0 from "./WhoIAmThanks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports